import { render, staticRenderFns } from "./OrgSaasOrganisationEdit.vue?vue&type=template&id=5225149c&scoped=true"
import script from "./OrgSaasOrganisationEdit.vue?vue&type=script&lang=js"
export * from "./OrgSaasOrganisationEdit.vue?vue&type=script&lang=js"
import style0 from "./OrgSaasOrganisationEdit.vue?vue&type=style&index=0&id=5225149c&prod&scoped=true&lang=css"
import style1 from "./OrgSaasOrganisationEdit.vue?vue&type=style&index=1&id=5225149c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5225149c",
  null
  
)

export default component.exports